import React from "react";
import Cars from "../../Components/Cars/Cars";
import "../../Components/Style/Cars/CarsIndex.css";

const CarsIndex = () => {
  return (
    <div className="cars-index">
      <Cars />
    </div>
  );
};

export default CarsIndex;
